<template>
<div class="content">

  <div class="swiper-box">
    <swiper class="box-container" :options="swiperOption" ref="mySwiper">
      <swiper-slide v-for="(item, index) in imgLists" :key="index" @touchmove.native="stopPlay" @touchend.native="play">
        <img class="swiper-image" :src="item.url" style="cursor: pointer;" alt="" v-on:click="imgclick(item.blog)">
      </swiper-slide>

      <div class="swiper-pagination" slot="pagination"></div>
      <div class="swiper-scrollbar" slot="scrollbar"></div>
    </swiper>
  </div>
  <el-row type="flex" justify="center">
    <el-col :span="23">
      <el-row>
        <el-col :xs="23" :sm="23" :md="8" :lg="8" :xl="8"><card :cardInfo="cardObject1"></card></el-col>
        <el-col :xs="23" :sm="23"  :md="8" :lg="8" :xl="8"><card :cardInfo="cardObject2"></card></el-col>
        <el-col :xs="23" :sm="23"  :md="8" :lg="8" :xl="8"><card :cardInfo="cardObject3"></card></el-col>
      </el-row>
    </el-col>
  </el-row>
  <el-divider></el-divider>
  <el-row type="flex" justify="center">
    <el-col :span="23">
  <el-row>
    <el-col :xs="23" :sm="23" :md="4" :lg="4" :xl="4"><recomIcon title="推薦"></recomIcon></el-col>
    <el-col :xs="23" :sm="23" :md="10" :lg="10" :xl="10">
      <recentMessage v-loading="newMessageLoading" :title="itemTitle2" :itemList="newMessageList" :clickurl="item2url"> </recentMessage>
    </el-col>
    <el-col  :xs="23" :sm="23" :md="10" :lg="10" :xl="10">
      <specialtopic v-loading="indexFirstLoading" :title="itemTitle1" :itemList="specialtopicList"></specialtopic>
    </el-col>
    <el-col :xs="23" :sm="23" :md="{span: 10, offset: 4}" :lg="{span: 10, offset: 4}" :xl="{span: 10, offset: 4}">
      <recentupdate v-loading="indexFirstLoading" :title="itemTitle" :itemList="indexFirstList"></recentupdate>
    </el-col>
    <el-col :xs="23" :sm="23" :md="10" :lg="10" :xl="10"><recommend :title="itemTitle3" :itemList="item3"></recommend></el-col>
  </el-row>
    </el-col>
  </el-row>
  <el-divider></el-divider>
  <el-row style="margin-bottom: 100px" v-loading="indexbottomLoading">
    <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6" v-for="bcard in indexbottom" :key="bcard.icon">
      <bottomcard :cardInfo="bcard"></bottomcard>
    </el-col>
  </el-row>
</div>
</template>
<script>
  import { mapMutations, mapState } from 'vuex'
  import card from '/components/playcard3'
  import bottomcard from '/components/bottomcard'
  import recommend from '/components/recommend'
  import recentMessage from '/components/recentMessage'
  import recentupdate from '/components/recentupdate'
  import specialtopic from '/components/specialtopic'
  import recomIcon from '/components/recomIcon'
  import {Swiper, SwiperSlide} from 'vue-awesome-swiper'
  import 'swiper/css/swiper.css'

  export default {
    data () {
      return {
        item2url: '/blog/archives/category/news/',
        imgLists: [
          {url: '/static/images/banner5.jpg', blog: '/blog/archives/211'},
          {url: '/static/images/banner4.jpg', blog: '/blog/archives/19469'},
          {url: '/static/images/banner1.jpg', blog: '/blog/archives/1423'},
          {url: '/static/images/banner2.jpg', blog: '/blog/archives/1682'},
          {url: '/static/images/banner3.jpg', blog: '/blog/archives/130'},
          {url: '/static/images/banner0.jpg', blog: '/blog/archives/8483'}
        ],
        swiperOption: {
          notNextTick: true,
          autoplay: {    // 自动播放
            delay: 10000,
            stopOnLastSlide: false,
            disableOnInteraction: false
          },
          loop: true,   // 循环
          directionType: 'horizontal', // 方向
          pagination: {               // 分页器
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true
          },
          navigation: {   // 左右按钮
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          },
          observer: true,  // 启动动态检查器(OB/观众/观看者)，当改变swiper的样式（例如隐藏/显示）或者修改swiper的子元素时，自动初始化swiper。
          observeParents: true,  // 将observe应用于Swiper的父元素。当Swiper的父元素变化时，例如window.resize，Swiper更新。
          setWrapperSize: true  // Swiper使用flexbox布局(display: flex)，
          // 开启这个设定会在Wrapper上添加等于slides相加的宽或高，在对flexbox布局的支持不是很好的浏览器中可能需要用到。
        },
        active: 0,
        cardObject1: {id: 1, src: '/static/images/aboutmasterchinkung.jpg', infoCh: '認識師父', infoEn: 'ABOUT MASTER CHIN KUNG', url: 'understand'},
        cardObject2: {id: 2, src: '/static/images/collectionebook.jpg', infoCh: '精華開示', infoEn: 'ESSENCE OF DHARMA TALK', url: 'jinghua'},
        cardObject3: {id: 3, src: '/static/images/essenceoftalk.jpg', infoCh: '講記著作', infoEn: 'COLLECTION OF EBOOKS', url: 'ebooklist'},
        carousels: [{id: 3, src: '/static/images/masterchinkong.png', name: '认识师父', label: 'about master chin kung'}],
        liitems: [{ id: 1, content: 'aaaaaa' }, { id: 2, content: 'bbbbbbbbbb' }, { id: 3, content: 'ccccccccc' }],
        itemTitle: '推薦學習',
        itemTitle1: '專欄主題',
        itemTitle2: '最新資訊',
        itemTitle3: '生活智慧',
        item3: [
          {title: '答疑解惑', contenturl: '/blog/archives/category/faq', type: 1},
          {title: '故事說法', contenturl: '/blog/archives/category/story', type: 1},
          {title: '淨心法語', contenturl: '/blog/archives/category/jingxin', type: 1},
          {title: '師說新語', contenturl: '/blog/archives/category/shishuo', type: 1},
          {title: '修福有福', contenturl: '/blog/archives/category/xiufu', type: 1},
          {title: '節日開示', contenturl: '/blog/archives/category/festival', type: 1}
        ],
        item2: [{title: '法音宣流', contenturl: 'http://www.amtb.org.tw/ans/ans.asp'},
          {title: '聽師父說', contenturl: 'http://www.amtb.org.tw/ans/ans.asp'},
          {title: '懂因果就能趨吉避凶', contenturl: 'http://www.amtb.org.tw/ans/ans.asp'},
          {title: '金剛經的智言慧語', contenturl: 'http://www.amtb.org.tw/ans/ans.asp'},
          {title: '法音普薰集', contenturl: 'http://www.amtb.org.tw/ans/ans.asp'}],
        newsItem: ''
      }
    },
    computed: {
      ...mapState(
        ['newMessageList', 'newMessageLoading', 'specialtopicList', 'indexFirstList', 'indexFirstLoading', 'indexbottom', 'indexbottomLoading']
      )
    },
    methods: {
      ...mapMutations([
        'INIT_NEWMESSAGELIST', 'INDEX_FIRSTLIST', 'IMG_INDEX'
      ]),
      imgclick (url) {
        window.open(url, '_self')
      },
      stopPlay () {
        this.mySwiper.autoplay.stop()
      },

      play () {
        this.mySwiper.autoplay.start()
      }
    },
    mounted () {
      this.INIT_NEWMESSAGELIST()
      this.INDEX_FIRSTLIST()
      this.IMG_INDEX()
      return this.$refs.mySwiper.swiper
    },
    components: {
      card,
      bottomcard,
      recommend,
      recentMessage,
      recentupdate,
      specialtopic,
      recomIcon,
      Swiper,
      SwiperSlide
    }

  }
</script>
<style lang="scss" rel="stylesheet/scss" scoped>
  .home {
  }
  .content{
    display: flex;
    flex-direction: column;
    background-color: #ffffff;
  }

    .carousel-item {
      background: white;
     display: flex;
    flex-direction: column;
     justify-content: center;
    align-items: center;
    }
  @media (max-device-width: 780px){
    .carousel-img{
      max-width: 780px;
      _width : expression(this.width > 780 ? "780px" : this.width);
    }
  }
  @media (max-device-width: 900px){
    .carousel-img{
      max-width: 900px;
      _width : expression(this.width > 900 ? "900px" : this.width);
    }
  }
  @media (max-device-width: 1080px){
    .carousel-img{
      max-width: expression(this.width);
      _width : expression(this.width > 1080 ? "1080px" : this.width);
    }
  }
  @media (max-device-width: 375px){
    .carousel-img{
      max-width: 375px;
      _width : expression(this.width > 1080 ? "1080px" : this.width);
    }
    .carousel-div{
      max-height: 100px;
    }
    .carousel-item{
      max-height: 100px !important;
    }
    .el-carousel__item{
      max-height: 100px !important;
    }

    .el-carousel__item:nth-child(2n) {
      background-color: #FFFFFF;
    }

    .el-carousel__item:nth-child(2n+1) {
      background-color: #ffffff;
    }
    .el-carousel__container{
      max-height: 100px;
      height: 100px;
    }
  }
  .swiper-image{
    width: 100%;
    }
</style>



// WEBPACK FOOTER //
// index.vue?6caa2cf6